import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function RouteAnalytics() {
	const location = useLocation()

	useEffect(() => {
		if (window.gtag) {
			window.gtag('event', 'page_view', {
				page_path: location.pathname,
			})
		}
	}, [location.pathname])

	return null
}
